export var InterestRateCountry;
(function (InterestRateCountry) {
    InterestRateCountry["UK"] = "UK";
})(InterestRateCountry || (InterestRateCountry = {}));
const interestRateAlias = {
    [InterestRateCountry.UK]: [`GB`, `UK`],
};
export function findByAlias(alias) {
    return Object.keys(interestRateAlias).find(key => {
        return interestRateAlias[key].includes(alias);
    });
}
export const allowedRegions = [
    ...Object.values(InterestRateCountry),
    ...Object.values(interestRateAlias).flat(),
];
//# sourceMappingURL=interestRate.js.map